<template>
    <div class="bottom-menu-bar">
        <div class="bottom-menu-side" @click="clickPiLun">
            <div class="bottom-menu-pilun" v-bind:class="{'bottom-menu-pilun-have' : personInfo.pipan != 0 || personInfo.nunpan != 0, 'bottom-menu-pilun-disable' : shareData && shareData.type == 4}">
                <i class="iconfont icon-plus-2"></i><span>批论</span>
                <span id="pilunRed" class="red-circle" v-if="settingConfigData.red_pipanlist == 0 || settingConfigData.red_lunpanlist == 0 || settingConfigData.red_sendlunpan == 0"></span>
            </div>
        </div>
        <div class="bottom-menu-mid">
            <div class="bottom-menu-list dsp-flex">
                <div class="bottom-menu-list-item" v-bind:class="{'cur': data.index == showDetailType}" v-for="data in tabList" :key="'tab' + data.text" @click="clickTab(data)" >
                    <span>{{data.text}}</span>
                </div>
                <div class="bottom-menu-list-item-report" v-bind:class="{'bottom-menu-list-item-report-org' : !aiButtonClickedStatus}" @click="clickReport">测算
                    <i class="iconbg iconbg-left icon-diamond" v-bind:class="{'icon-diamond-org': personInfo.ai != 0}"></i>
                    <i class="iconbg iconbg-right icon-diamond" v-bind:class="{'icon-diamond-org': personInfo.ai != 0}"></i>
                </div>
            </div>
        </div>
        <!-- <div class="bottom-menu-side buttom-menu-report-side">
            <div class="buttom-menu-report" @click="clickReport">
                <i class="iconbg icon-report" v-bind:class="{'icon-report-org': personInfo.ai != 0}"></i>
                <p class="buttom-menu-report-text">测算</p>
            </div>
        </div> -->
        <div class="bottom-menu-side" @click="clickQrCode">
            <div class="bottom-menu-img">
                <qrcode id='qrImg' tag="img" :options="{size: 100, padding: 0}" :value="qrCodeValue" ></qrcode>
                <i class="iconbg icon-qr-logo"></i>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DetailBottomBar',
    data(){
        return {
            tabList: [
                {text: '资料', index: 0, type: 'info'},
                {text: '流运', index: 1, type: 'liuyun'},
                {text: '神煞', index: 2, type: 'shensha'},
                {text: '合化', index: 3, type: 'relation'},
            ]
        }
    },
    computed: {
        aiButtonClickedStatus() {
            return this.$store.state.reminder.aiButtonClickedStatus;
        },
        personInfo() {
            return this.$store.state.detail.personInfo;
        },
        showDetailType() {
            return this.$store.state.detail.showDetailType
        },
        qrCodeValue() {
            return this.$store.state.detail.qrCodeValue;
        },
        settingConfigData() {
            return this.$store.state.setting.settingConfigData;
        },
        shareData() {
            return this.$store.state.share.shareData;
        }
    },
    mounted: function() {
        var me = this;
        // 手动设置二维码的样式大小
        setTimeout(() => {
            me.initDom();
        }, 20);

        // 添加改变屏幕大小后的适配,for Wechat PC
        window.onresize = function() {
            setTimeout(() => {
                me.initDom();
            }, 20);
        }
        window.onorientationchange = function() {
            setTimeout(() => {
                me.initDom();
            }, 20);
        }
        window.addEventListener("onorientationchange" in window ? "orientationchange" : "resize", function(){
            setTimeout(() => {
                me.initDom();
            }, 20);
        }, false);
    },
    methods:{
        initDom() {
            var qrDiv = document.getElementsByClassName('bottom-menu-img')[0];
            if(qrDiv) {
                qrDiv.style.width = qrDiv.clientHeight + 'px';
            }
            var qrImg = document.getElementById('qrImg');
            if(qrImg && qrDiv) {
                qrImg.style.width = qrDiv.clientHeight + 5 + 'px';
                qrImg.style.height = qrDiv.clientHeight + 5 + 'px';
            }
            var pilunDiv = document.getElementsByClassName('bottom-menu-pilun')[0];
            if(pilunDiv) {
                pilunDiv.style.width = pilunDiv.clientHeight + 'px';
                pilunDiv.style.lineHeight = (pilunDiv.clientHeight - 2) + 'px';
            }
            var redCircleNode = document.getElementById('pilunRed');
            if(redCircleNode) {
                redCircleNode.style.left = (pilunDiv.clientHeight - redCircleNode.clientHeight - 5) + 'px';
            }
        },
        clickTab(data){
            this.$store.state.detail.showDetailType = data.index;
            var contentDiv = document.getElementsByClassName("detail-content")[0];
            if(data.index == 2){
                // 处理神煞数据
                this.$store.dispatch('detail/initDetailShensha');
            }else if(data.index == 3){
                // 处理合化冲数据
                this.$store.dispatch('detail/initDetailHehuachong');
            }
            
            // 处理UI逻辑
            if(data.index == 3){
                contentDiv.style.overflowY = 'auto';
            }else{
                contentDiv.style.overflowY = 'hidden';
            }
        },
        clickQrCode(){
            this.$store.state.detail.showQrCodePop = true;
        },
        clickPiLun() {
            if(this.shareData.type == 4) {
                this.$store.state.detail.showDetailSharePop = true;
            }else {
                this.$store.dispatch('detail/getBaziNum');
            }
        },
        clickReport() {
            var me = this, detailInfo = this.personInfo,
                curPath = this.$router.history.current.path,
                curParams = this.$router.history.current.params;;
            this.$store.dispatch('report/initReportAIConfig');
            this.$store.dispatch('report/getReportInfo', {
                detailInfo: detailInfo,
                cb: function() {
                    // 更新状态
                    var params = {"aitips": 1};
                    me.$store.dispatch('reminder/udpateExtList', {
                        params: params
                    });
                    // 处理分享页面
                    if(curPath.indexOf('share') != -1) {
                        me.$router.push({
                            path: '/report/share/' + detailInfo.id
                        });
                        return;
                    }else {
                        if(curParams && curParams.from && curParams.from != '') {
                            me.$router.replace('/report/'+curParams.from+'/'+curParams.id);
                        }
                    }
                }
            })
        }
    }
}
</script>